export default "__VITE_ASSET__DVg388GR__"